import React from 'react';
import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { MeasurementUtility } from '@inter-ikea-kompis/utilities';
import { useTranslations } from 'hooks/useTranslations';
import { useServiceSettings } from 'contexts/serviceSettings';

const Wrapper = styled.div`
  padding: 0;
`;

function FrameExtensionsInfo() {
  const { formatMessage } = useIntl();
  const { unit, useMetric } = useTranslations();
  const { translations } = useServiceSettings();

  const height = useMetric ? 202 : MeasurementUtility.metricToImperial(translations.kompis, 2020);

  return (
    <Wrapper>
      <SkapaInlineMessage
        body={formatMessage({ id: 'storageone.productListFrameExtensionsInfo' }, { height, unit })}
        variant={InlineMessageVariantEnum.INFORMATIVE}
        ssrIcon={InformationCircle}
        subtle
      />
    </Wrapper>
  );
}

export default FrameExtensionsInfo;
